module.exports = __webpack_public_path__ + "img/nope.73237e13.png";